export default __webpack_public_path__ + "static/media/leurovisiu.40426704.jpg";